// extracted by mini-css-extract-plugin
export default {"filterItemBadgesContainer":"ItemBadgesContainer_filterItemBadgesContainer__Jazbq"};